const formataDateInput = date => {
  const elem = date.split("/")
  const jour = elem[0]
  const mois = elem[1]
  const annee = elem[2]

  var date_ok = annee + "-" + mois + "-" + jour
  return date_ok
}

export default formataDateInput
